import React, { memo } from 'react';

const LoginIcon = (props) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.99999 9H0.0499878C0.549988 3.947 4.81399 0 9.99999 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 9.99999 20C4.81499 20 0.550988 16.053 0.0499878 11H7.99999V14L13 10L7.99999 6V9Z"
            fill="currentColor"
        />
    </svg>
);

export default memo(LoginIcon);
